import { NavioHorse } from '../../svg/NavioHorse';
import { ThreePeakMountainSnowflake } from '../../svg/ThreePeakMountainSnowflake';
import { Trailer } from '../../svg/Trailer';
import { Wheel } from '../../svg/Wheel';
import { WheelAngle } from '../../svg/WheelAngle';

// Only icons lucide-react-native genuinely lacks belong here -- wheels, Trailer and the 3PMSF tire mark.
// Each one must follow the contract in the package README: one paint source (the `color`
// prop), no hardcoded colors, geometry inside r <= 10 of the 24x24 viewBox. Callers style a
// NoddiIcon exactly like a lucide one -- `color`, or an inherited `currentColor`, sized via
// `size` -- so an icon that bakes in a second color fails silently on any surface that is
// not the one it was drawn against. Enforced by `noddi/no-hardcoded-color-in-icon`.
export const customIconMap = {
  Horse: NavioHorse,
  ThreePeakMountainSnowflake,
  Trailer,
  WheelAngle,
  Wheel
};
